 
import {
  getScheduledMaintenanceFail,
  getScheduledMaintenanceStarted,
  getScheduledMaintenanceSuccess
} from '../../../reducer/schedule-maintenance/GetScheduledMaintenanceReducer';
import { getScheduledMaintenance } from '../../actionType/schedule-maintenance/GetScheduledMaintenanceTypes';
import {
  GetScheduledMaintenanceFailure,
  GetScheduledMaintenanceFailurePayload,
  GetScheduledMaintenanceRequest,
  GetScheduledMaintenanceStarted,
  GetScheduledMaintenanceSuccess,
  GetScheduledMaintenanceSuccessPayload
} from '../../types/schedule-maintenance/GetScheduledMaintenanceTypes';

export const getScheduledMaintenanceRequest = (
  reqObject: any
): GetScheduledMaintenanceRequest => ({
  type: getScheduledMaintenance.FETCH_SCHEDULED_MAINTENANCE_REQUEST,
  requestObject: reqObject
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getScheduledMaintenanceStart =
  (): GetScheduledMaintenanceStarted => ({
    type: getScheduledMaintenanceStarted.type
  });

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getScheduledMaintenanceSuccessful = (
  payload: GetScheduledMaintenanceSuccessPayload
): GetScheduledMaintenanceSuccess => ({
  type: getScheduledMaintenanceSuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getScheduledMaintenanceFailure = (
  payload: GetScheduledMaintenanceFailurePayload
): GetScheduledMaintenanceFailure => ({
  type: getScheduledMaintenanceFail.type,
  payload
});
